import { render, staticRenderFns } from "./AdjustRewards.vue?vue&type=template&id=1a85dac6"
import script from "./AdjustRewards.vue?vue&type=script&lang=js"
export * from "./AdjustRewards.vue?vue&type=script&lang=js"
import style0 from "./AdjustRewards.vue?vue&type=style&index=0&id=1a85dac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports